// How often the checkout asks the backend whether a pix has been paid. Nothing in the pix protocol
// says 12s — it is a cadence this feature picked. usePixPayment takes it as a parameter, so a flow
// could be given its own.
export const PIX_POLLING_INTERVAL = 12000;
